import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// theme
import { bgGradient } from 'src/theme/css';
//
import { MotionContainer, varFade } from 'src/components/animate';

// ----------------------------------------------------------------------

const CONTACTS = [
  {
    country: 'UAE',
    // address: '508 Bridle Avenue Newnan, GA 30263',
    // phoneNumber: '(239) 555-0108',
  },
  // {
  //   country: 'KSA',
  //   // address: '508 Bridle Avenue Newnan, GA 30263',
  //   // phoneNumber: '(319) 555-0115',
  // },
  {
    country: 'Lebanon',
    // address: '508 Bridle Avenue Newnan, GA 30263',
    // phoneNumber: '(252) 555-0126',
  },
];

// ----------------------------------------------------------------------

export default function ContactHero() {
  return (
    <>
      {/* Section 1: Background Container */}
      <Box
        sx={{
          ...bgGradient({
            color: 'transparent',
            imgUrl: '/assets/images/contact/Hero.png',
          }),
          height: { xs: 300, md: 560 },
          overflow: 'hidden',
          position: 'relative',
          backgroundPosition: 'center -50px',
          backgroundSize: 'cover',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: 'white',
            width: '100%',
            fontSize: { xs: '2rem', md: '3rem', lg: '4rem' },
            pr: { xs: 10, md: 20 },
            pl: { xs: 10, md: 20 },
            textAlign: 'center',
            position: 'absolute',
            bottom: { xs: 70, md: 100, lg: 150 },
            zIndex: 100,
          }}
        >
          The future we want to achieve is valuable and seamless for the B2B E-commerce needs
        </Typography>
      </Box>

      {/* Section 2: Where to find us Content */}
      {/* <Container>
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'unset' },
            mb: { xs: 10, md: 15 },
            pt: { xs: 5, md: 5 },
          }}
        >
          <TextAnimate text="Where" sx={{ color: 'primary.main' }} variants={varFade().inRight} />
          <br />

          <Stack spacing={2} display="inline-flex" direction="row">
            <TextAnimate text="to" />
            <TextAnimate text="find" />
            <TextAnimate text="us?" />
          </Stack>

          <Stack
            spacing={5}
            alignItems={{ xs: 'center', md: 'unset' }}
            direction={{ xs: 'column', md: 'row' }}
            sx={{ mt: 5 }}
          >
            {CONTACTS.map((contact) => (
              <Stack key={contact?.country} sx={{ maxWidth: 180 }}>
                <m.div variants={varFade().in}>
                  <Typography variant="h6" gutterBottom>
                    {contact?.country}
                  </Typography>
                </m.div>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Container> */}
    </>
  );
}

// ----------------------------------------------------------------------

function TextAnimate({ text, variants, sx, ...other }) {
  return (
    <Box
      component={m.div}
      sx={{
        typography: 'h1',
        overflow: 'hidden',
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      {text.split('').map((letter, index) => (
        <m.span key={index} variants={variants || varFade().inUp}>
          {letter}
        </m.span>
      ))}
    </Box>
  );
}

TextAnimate.propTypes = {
  sx: PropTypes.object,
  text: PropTypes.string,
  variants: PropTypes.object,
};

export function ContactHeroBackground() {
  return (
    <Box
      sx={{
        ...bgGradient({
          color: 'transparent',
          imgUrl: '/assets/images/contact/Hero.png',
        }),
        height: { md: 560 },
        py: { xs: 10, md: 0 },
        overflow: 'hidden',
        position: 'relative',
        mb: 15,
      }}
    />
  );
}
export function ContactFindUs() {
  return (
    <Container component={MotionContainer}>
      <Box
        sx={{
          bottom: { md: 80 },
          position: { md: 'absolute' },
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <TextAnimate text="Where" sx={{ color: 'primary.main' }} variants={varFade().inRight} />
        <br />

        <Stack spacing={2} display="inline-flex" direction="row" sx={{ color: 'common.white' }}>
          <TextAnimate text="to" />
          <TextAnimate text="find" />
          <TextAnimate text="us?" />
        </Stack>

        <Stack
          spacing={5}
          alignItems={{ xs: 'center', md: 'unset' }}
          direction={{ xs: 'column', md: 'row' }}
          sx={{ mt: 5, color: 'common.white' }}
        >
          {CONTACTS?.map((contact) => (
            <Stack key={contact?.country} sx={{ maxWidth: 180 }}>
              <m.div variants={varFade().in}>
                <Typography variant="h6" gutterBottom>
                  {contact?.country}
                </Typography>
              </m.div>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Container>
  );
}
